import { render, staticRenderFns } from "./VisitDetails.vue?vue&type=template&id=66f10fb7"
import script from "./VisitDetails.vue?vue&type=script&lang=js"
export * from "./VisitDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66f10fb7')) {
      api.createRecord('66f10fb7', component.options)
    } else {
      api.reload('66f10fb7', component.options)
    }
    module.hot.accept("./VisitDetails.vue?vue&type=template&id=66f10fb7", function () {
      api.rerender('66f10fb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/periodEnd/components/VisitDetails.vue"
export default component.exports